import type {PermissionsRecordType} from '../permissions';

export const rolePermissions = {
  readRole: {
    actionId: 'READ',
    resourceId: 'ROLE',
    scopes: [],
  },
  createRole: {
    actionId: 'CREATE',
    resourceId: 'ROLE',
    scopes: [],
  },
  updateRole: {
    actionId: 'UPDATE',
    resourceId: 'ROLE',
    scopes: [],
  },
  deleteRole: {
    actionId: 'DELETE',
    resourceId: 'ROLE',
    scopes: [],
  },
} satisfies PermissionsRecordType;
